/**
 * PNA (Pocztowe Numery Adresowe) ajax input sugestions
 * how to use:
 * include .js in Your project after jquery
 * spispna.xsl (add ID colummn, add PNA_INT (post code as INT), and rename colummns title to english like so: PNA	CITY	STREET	NUMBER	BOROUGH	COUNTY	VOIVODESHIP )
 * Export spispna.xsl as spispna.csv and import it to Your database ( follow this: https://phoenixnap.com/kb/import-csv-file-into-mysql )
 *
 * HTML:
 * 	<label>
 *    <input data-pna="true" type="text" >
 *  		<div id="sugest-postcode"></div>
 *  </label>
 */

(() => {
  //Disable arrow key scrolling
  // window.addEventListener(
  //   "keydown",
  //   function (e) {
  //     // space and arrow keys
  //     if ([32, 37, 38, 39, 40].indexOf(e.keyCode) > -1) {
  //       e.preventDefault();
  //     }
  //   },
  //   false
  // );

  //POST CODE
  const postCodeInput = document.querySelector("input[data-pna]");
  let allowpress = true;

  // turn off psae event
  postCodeInput.addEventListener("paste", function (ev) {
    event.preventDefault();
    return;
  });
  postCodeInput.addEventListener("keydown", function (ev) {
    console.log( allowpress );
    
    if(allowpress === true){

      allowpress = false;
      if (
        $("input[name ='country']").val() == "Polska" ||
        $("input[name ='country']").val() == "Poland"
        ) {
          if (ev.which === 40) {
            //enter key
            var tabindex = $(this).attr("tabindex");
            tabindex++; //increment tabindex
            $("#sugest-pna p[tabindex=" + tabindex + "]").focus();
            document.querySelector("#sugest-pna").classList.add("active");
          }
          
          if (/^[\d{0,1}?(\-)?\d{0,2}?]{0,5}$/.test(this.value)) {
            if (this.value.length === 2) {
              this.value = this.value + "-";
            }
            if (
              this.value.length === 3 &&
            this.value[this.value.length - 1] === "-" &&
            ev.keyCode == 8
          ) {
            ev.preventDefault();
            this.value = this.value.slice(0, -2);
          }
        }
      }

    }
    else{
      ev.preventDefault();

    }

    return;
  });

  
  postCodeInput.addEventListener("keyup", function (ev) {


    if (
      $("input[name ='country']").val() == "Polska" ||
      $("input[name ='country']").val() == "Poland"
    ) {
      if (this.value[this.value.length - 1] === "-") {
        this.value = this.value.slice(0, -1);
      }
      if (/^[\d{0,1}?(\-)?\d{0,2}?]{0,6}$/.test(this.value)) {
        ajax_call(this.value, "pna");
      } else {
        this.value = this.value.slice(0, -1);
      }
    }
    allowpress = true;

  });

  //CITY
  const cityInput = document.querySelector("input[data-city]");

  cityInput.addEventListener("keyup", function (ev) {
    if (
      $("input[name ='country']").val() == "Polska" ||
      $("input[name ='country']").val() == "Poland"
    ) {
      ajax_call(this.value, "city");
    }
  });

  cityInput.addEventListener("keydown", function (ev) {
    if (
      $("input[name ='country']").val() == "Polska" ||
      $("input[name ='country']").val() == "Poland"
    ) {
      if (ev.which === 40) {
        var tabindex = $(this).attr("tabindex");
        tabindex++; //increment tabindex
        $("#sugest-city p[tabindex=" + tabindex + "]").focus();
        document.querySelector("#sugest-city").classList.add("active");
      }
    }
  });
  cityInput.addEventListener("mousedown", function (ev) {
    if (
      $("input[name ='country']").val() == "Polska" ||
      $("input[name ='country']").val() == "Poland"
    ) {
      ajax_call(this.value, "city");
    }
  });

  cityInput.addEventListener("focus", function (ev) {
    if (
      $("input[name ='country']").val() == "Polska" ||
      $("input[name ='country']").val() == "Poland"
    ) {
      ajax_call(this.value, "city");
    }
  });
  //STREET
  const streetInput = document.querySelector("input[data-street]");
  streetInput.addEventListener("keyup", function (ev) {
    if (
      $("input[name ='country']").val() == "Polska" ||
      $("input[name ='country']").val() == "Poland"
    ) {
      ajax_call(this.value, "street");
    }
  });

  streetInput.addEventListener("mousedown", function (ev) {
    if (
      $("input[name ='country']").val() == "Polska" ||
      $("input[name ='country']").val() == "Poland"
    ) {
      ajax_call(this.value, "street");
    }
  });

  streetInput.addEventListener("keydown", function (ev) {
    if (
      $("input[name ='country']").val() == "Polska" ||
      $("input[name ='country']").val() == "Poland"
    ) {
      if (ev.which === 40) {
        var tabindex = $(this).attr("tabindex");
        tabindex++; //increment tabindex
        $("#sugest-street p[tabindex=" + tabindex + "]").focus();
        document.querySelector("#sugest-street").classList.add("active");
      }
    }
  });
})();

function ajax_call(value, type) {
  // AJAX call
  const data = {
    userinput: value,
    postcode: document.querySelector("input[data-pna]").value,
    city: document.querySelector("input[data-city]").value,
    // street: document.querySelector("input[data-street]").value,
    fieldtype: type,
    action: "pna_ajax", //php function
  };
  $.ajax({
    url: my_ajax_object.ajaxurl,
    type: "post",
    dataType: "json",
    data: data,
    beforeSend: function () {},
    success: function (response) {
      if (type == "pna") {
        document.querySelector("#sugest-city").classList.remove("active");
        document.querySelector("#sugest-street").classList.remove("active");
        $("#sugest-" + type + "").empty();
        $("#sugest-city").empty();

        response.forEach((val, index) => {
          let tmpNumber = +index + 1;
          $("#sugest-" + type + "").append(
            "<p tabindex=" +
            tmpNumber +
            " data-type" +
            type +
            '="' +
            val[type.toUpperCase()] +
            '" class="select-' +
            type +
            '">' +
            val[type.toUpperCase()] +
            "</p>"
            );
            // console.log(response);

          let pnaElement = document.querySelectorAll(".select-" + type + "");
          pnaElement.forEach((el) => {
            el.addEventListener("click", () => {
              document.querySelector(
                "input[data-" + type + "]"
              ).value = el.getAttribute("data-type" + type + "");
              // document.querySelector("input[data-city]").focus();
              $("#sugest-" + type + "").empty();
            });
          });

          // select value
          document.querySelectorAll("#sugest-pna p[tabindex]").forEach((el) => {
            el.addEventListener("keyup", function (event) {
              if (event.keyCode === 13) {
                event.preventDefault();
                if ($("#sugest-pna p[tabindex]:focus").attr("data-typepna")) {
                  document.querySelector("input[data-pna]").value = $(
                    "#sugest-pna p[tabindex]:focus"
                  ).attr("data-typepna");
                  $("#sugest-" + type + "").empty();
                  document.querySelector("input[data-city]").focus();
                }
              }
              if (event.which === 40) {
                //enter key
                event.preventDefault();
                var tabindex = $(this).attr("tabindex");
                tabindex++; //increment tabindex
                $("#sugest-pna p[tabindex=" + tabindex + "]").focus();
              }
              if (event.which === 38) {
                //enter key
                event.preventDefault();
                var tabindex = $(this).attr("tabindex");
                tabindex--; //increment tabindex
                $("#sugest-pna p[tabindex=" + tabindex + "]").focus();
              }
            });
          });
          document.querySelector("input[data-pna]").focus();
        });
      }

      if (type == "city") {
        document.querySelector("#sugest-pna").classList.remove("active");
        document.querySelector("#sugest-street").classList.remove("active");

        $("#sugest-" + type + "").empty();
        // console.log(response);
        response.forEach((val, index) => {
          // console.log(val);

          let tmpNumber = +index + 2;
          $("#sugest-" + type + "").append(
            "<p tabindex=" +
              tmpNumber +
              " data-type" +
              type +
              '="' +
              val[type.toUpperCase()] +
              '" class="select-' +
              type +
              '">' +
              val[type.toUpperCase()] +
              "</p>"
          );

          let pnaElement = document.querySelectorAll(".select-" + type + "");
          pnaElement.forEach((el) => {
            el.addEventListener("click", () => {
              document.querySelector(
                "input[data-" + type + "]"
              ).value = el.getAttribute("data-type" + type + "");
              $("#sugest-" + type + "").empty();
            });
          });
          document
            .querySelectorAll("#sugest-city p[tabindex]")
            .forEach((el) => {
              el.addEventListener("keyup", function (event) {
                //enter
                if (event.keyCode === 13) {
                  event.preventDefault();
                  if (
                    $("#sugest-city p[tabindex]:focus").attr("data-typecity")
                  ) {
                    document.querySelector("input[data-city]").value = $(
                      "#sugest-city p[tabindex]:focus"
                    ).attr("data-typecity");
                    $("#sugest-" + type + "").empty();
                    document.querySelector("input[data-street]").focus();
                  }
                }
                //arrow key down
                if (event.which === 40) {
                  event.preventDefault();
                  var tabindex = $(this).attr("tabindex");
                  tabindex++; //increment tabindex
                  $("#sugest-city p[tabindex=" + tabindex + "]").focus();
                }

                //arrow up down
                if (event.which === 38) {
                  //enter key
                  event.preventDefault();
                  var tabindex = $(this).attr("tabindex");
                  tabindex--; //increment tabindex
                  $("#sugest-city p[tabindex=" + tabindex + "]").focus();
                }
              });
            });
        });
        // document.querySelector("input[data-city]").focus();
      }

      if (type == "street") {
        document.querySelector("#sugest-pna").classList.remove("active");
        document.querySelector("#sugest-city").classList.remove("active");
        $("#sugest-" + type + "").empty();
        response.forEach((val, index) => {
          let tmpNumber = +index + 2;
          $("#sugest-" + type + "").append(
            "<p tabindex=" +
              tmpNumber +
              " data-type" +
              type +
              '="' +
              val[type.toUpperCase()] +
              '" class="select-' +
              type +
              '">' +
              val[type.toUpperCase()] +
              "</p>"
          );

          let pnaElement = document.querySelectorAll(".select-" + type + "");
          pnaElement.forEach((el) => {
            el.addEventListener("click", () => {
              document.querySelector(
                "input[data-" + type + "]"
              ).value = el.getAttribute("data-type" + type + "");
              $("#sugest-" + type + "").empty();
            });
          });

          document
            .querySelectorAll("#sugest-street p[tabindex]")
            .forEach((el) => {
              el.addEventListener("keyup", function (event) {
                //enter
                if (event.keyCode === 13) {
                  event.preventDefault();
                  if (
                    $("#sugest-street p[tabindex]:focus").attr(
                      "data-typestreet"
                    )
                  ) {
                    document.querySelector("input[data-street]").value = $(
                      "#sugest-street p[tabindex]:focus"
                    ).attr("data-typestreet");
                    $("#sugest-" + type + "").empty();
                    document.querySelector("input[data-street]").focus();
                  }
                }
                //arrow key down
                if (event.which === 40) {
                  event.preventDefault();
                  var tabindex = $(this).attr("tabindex");
                  tabindex++; //increment tabindex
                  $("#sugest-street p[tabindex=" + tabindex + "]").focus();
                }

                //arrow up down
                if (event.which === 38) {
                  //enter key
                  event.preventDefault();
                  var tabindex = $(this).attr("tabindex");
                  tabindex--; //increment tabindex
                  $("#sugest-street p[tabindex=" + tabindex + "]").focus();
                }
              });
            });
        });
      }
    },
    error: function (response) {
      console.log("error");
    },
    complete: function () {
      // document.querySelector("input[data-" + type + "]").focus();
    },
  });
  //END of AJAX
}
